// extracted by mini-css-extract-plugin
export default {"container":"styles_container__hc3uP","cell":"styles_cell__TRvWT","link":"styles_link__jTe6v","header":"styles_header__Wt66r","bottom":"styles_bottom__y2DEr"};